export default () => {
	return (
		<script type="text/javascript" src="https://cdn.riverhit.com/sdk/slider_inline/?zid=2920" />
	)
};



// WEBPACK FOOTER //
// components/ads/Outstream.js